<template>
	<section id="file-list" class="" >
    <div class="list" :class="{'col5': col == 5, 'col3': col == 3, 'col4': col == 4}">

      <div v-for="(item, index) in files" class="item" :class="{'disabled': item.status == 2 }" :href="item.url" :key="item.id" v-show="item.lang.name === language">

          <div class="header">
            <div class="name">{{item.name}}</div>
            <img :src="item.thumb">
          </div>
          <div class="data">
            <div v-if="(market === 'PT' && item.description) || market === 'ES'" class="description">{{item.description}}</div>
          </div>
          <a @click="log(item)" target="_blank" :href="item.file" v-if="item.status == 1 && item.download != 0" class="button download">{{ $t('general.download') }}</a>
          <div v-if="item.status == 2" class="button soon">{{ $t('general.soon') }}</div>

      </div>

    </div>


	</section>
</template>

<script>

export default {
  props: {type: Number, search: String, col: Number},
  data () {
    return {
      domain_url: window.location.origin+"/r/",
    }
  },
  computed: {
    user_id() {
      var data = this.$store.getters['user/getUser'];
      return data.id;
    },
    language() {
      return this.$store.state.language;
    },
    files() {
      if(this.search) {
        var self = this;
        //this.$store.commit('setLoading', true);
        return self.$store.getters['files/searchFiles'];
        
      }
      else{
          return this.$store.getters['files/getFiles']( this.$store.getters['files/getCurrentCategory'] );
      }
    },
    file() {
      return this.$store.getters['files/getCurrentFile'];
    },
    not_admin() {
      return !this.$store.getters['user/isAdmin'];
    },
    market() {
      return this.$store.getters['getMarket'];
    }
  },
  methods: {
    select(item) {
      this.$store.commit('files/setCurrentFile', item);
    },
    order(item) {
      this.$store.commit('files/setCurrentFile', item);
      this.$router.push('/order/'+item.id);
    },
    cart(item) {
      var order = {from: { file: item.id, filename: item.name, image: item.thumb}, to: { file: false, filename: false, size: ''}, method: 2, units: false, billed: false, shipped: false, custom_ship: '', custom: '', custom_file: null, params: {}};

      this.$store.commit( 'orders/addOrderToCart', order );
      this.$store.commit( 'files/unsetCurrentFile' );
      this.$router.push( { name: 'cart' } );
    },
    date( date ){
      return moment( date ).valueOf();
    },
    log(file) {
      this.$store.dispatch('files/logToolkit', {resource_id: file.id, user_id: this.user_id});
    }
  },
  mounted() {
    if(this.search) {
      this.$store.dispatch('files/searchFiles', {search: this.search}).then(function() {
      });
    } else if( this.$store.getters['files/getCurrentCategory'] ) {
      // var params = {
      //   id: this.$store.getters['files/getCurrentCategory']
      // };
      
      // this.$store.dispatch('files/loadFiles', params).then(function() {
      //   //this.loading = false; 
      // })
    }

  },
  created() {
      // if(this.search) {
      //     var self = this;
      //     this.$store.dispatch('files/searchFiles', {search: this.search}).then(function() {
      //         self.$store.commit('setLoading', false);
      //         return self.$store.getters['files/searchFiles'];
      //     });
      // }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  #file-list {
    padding: 10px;
    overflow: hidden;
    width: 100%;

    .col5 {
      .item {
        width: 20%;
      }
    }
  }

  /* ITEM */
  .item {
    display: inline-block;
    width: 20%;
    vertical-align: top;
    margin: 20px;
    background-color: #eee;
    border-radius: 5px;
    overflow: hidden;
    height: 50%;

    &.disabled {
      filter: grayscale(40%);
      opacity: 0.7;

      .download:hover {
        background-color: #aaa;
        cursor: auto;
        color: currentColor;
      }
    }

    .header {
      overflow: hidden;
      height: 200px;
      position: relative;

      .name {
        z-index: 2;
        position: absolute;
        color: white;
        font-family: Speedee-Bold;
        font-size: 22px;
        top:10vh;
        background-color: rgba(0,0,0,0.8);
        padding: 5px 15px;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
      }

      img {
        z-index: 1;
        bottom: 0;
        width: 100%;
        text-align: center;
        /* filter: grayscale(50%); */
        z-index: 1;
        position: absolute;
        left: 0;
      }
    }

    .description {
      height: 150px;
      font-size: 15px;
      padding: 20px;
      text-align: center;
    }

    .button {
      width: 100%;
      background-color: #aaa;
      padding: 10px;
      font-family: Speedee;
      font-size: 18px;
      display: inline-block;
      text-decoration: none;
      color: inherit;
        
      &.soon {
        cursor: auto;
      }

      &.download {
        cursor: pointer;

        &:hover {
          color: black;
          background-color: var(--main_color);
        }
      }
    }
  }

</style>
